import { Container } from 'react-bootstrap';
import '../style/plans.css';
import '../style/service.css';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { useRef } from 'react';
import { db } from '../database/firebase';
import { collection,getDocs } from 'firebase/firestore';
import { useState,useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Plans() {
  const navigate = useNavigate();
const [activeLink, setActiveLink] = useState(""); // حالة لتخزين الرابط النشط

const handleClick = (e, path) => {
  e.preventDefault(); // منع إعادة تحميل الصفحة
  setActiveLink(path); // تحديث المسار النشط
  navigate(path); // التنقل باستخدام React Router
};
    
  const [services, setserivces] = useState([]); 
  const [uppp,setuppp]=useState("")
  useEffect(() => {
      const fetchUsers = async () => {
          const querySnapshot = await getDocs(collection(db, "palns"));
          const usersArray = querySnapshot.docs.map(doc => ({
              id: doc.id,
              ...doc.data()
            }));
          setserivces(usersArray);
          console.log(services)

        };
        fetchUsers();

  }, [uppp]);


  const sliderRef = useRef(null);

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: false,
    swipe: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  const nextSlide = () => {
    if (sliderRef.current) {
      sliderRef.current.slickNext();
    }
  };
  return (
    <div className='palns'>
      <Container>
        <div className='up-plans'>
            <h6>unsere Preise</h6>
            <h2>Wählen Sie aus unseren günstigsten <br/> Plänen und Preisen</h2>
        </div>
        <div className='dwon-plans'></div>

        <div className='slider-box'>
          <div className='slider-container'>
            <Slider ref={sliderRef} {...settings}>
              {services.map(item => (
                <div key={item.id} className='slide'>
               
        <div className='card-plans'>
            <div className='title'><h3>{item.title}</h3></div>
            <div className='card-p-in'>${item.price}/monthly</div>
            <ul>
                <li>{item.skils1}</li>
                <li>{item.skils2}</li>
                <li>{item.skils3}</li>
                <li>{item.skils4}</li>
                <li>{item.skils5}</li>
                <li>{item.skils6}</li>
            </ul>
           <div className='clas-btn'> <button onClick={(e) => handleClick(e, "/contact")} className='paln-btn'>Jetzt abonnieren</button></div>
        </div>
                </div>
              ))}
            </Slider>
          </div>
          <div className='next-button-container'>
            <button className='next-button' onClick={nextSlide}>
            <i class='fa-solid fa-arrow-right'></i>
            </button>
          </div>
        </div>













      </Container>
    </div>
  );
}
